<template>
  <div class="homePage">
    <div class="homePage_top">
      <div class="homePage_l">
        <span>佛燃科技阴保数据统计</span>
        <div
          @click="handleHome"
          class="gongzuo"
        >
          <img
            src="~@/assets/images/home-fan.png"
            alt=""
          >
          工作台
        </div>
        <div class="guanxian">
          <a-select
            v-model="queryParam.pipelineId"
            placeholder="请选择所属管线"
            allow-clear
            @change="pipelineIdChange"
            show-search
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in pipelineList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.pipelineName }}
            </a-select-option>
          </a-select>
          <a-select
            v-model="queryParam.deviceCode"
            style="width: 100%"
            placeholder="请选择设备"
            allow-clear
            @change="handleChange"
            show-search
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in deviceList"
              :key="item.deviceCode"
              :value="item.deviceCode"
            >
              {{ item.deviceName }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div class="homePage_r">
        <img
          src="~@/assets/images/nao.png"
          alt=""
        >
        {{ date }}
        <div>
          {{ week }}
        </div>
        {{ dates }}
      </div>
    </div>
    <div class="home_content">
      <div class="content_l">
        <div class="content_l_t">
          <div class="content_l_u">
            <div></div>
            保护统计
          </div>
          <div class="content_l_y">
            <bingChart :chartData="chartData1"></bingChart>
          </div>
        </div>
        <div class="content_l_t">
          <div class="content_l_u">
            <div></div>
            设备状态
          </div>
          <div class="content_l_y">
            <bingCharts :chartData="chartData2"></bingCharts>
            <div class="content_l_p">
              <div>{{ info.total ? info.total : 0 }}</div>
              <div class="content_l_k">共计(台)</div>
            </div>
          </div>
        </div>
      </div>
      <div class="con_map">
        <GdMap ref="map"></GdMap>
      </div>
      <div class="content_l">
        <div class="content_l_t">
          <div class="content_l_u">
            <div></div>
            设备信息报警
          </div>
          <div class="content_l_y con_y_u">
            <!-- <bingChart></bingChart> -->
            <div class="con_item" v-for="(item, index) in dataList" :key="index" @click="handleDev(item)">
              <a-popover :title="item.deviceName" trigger="hover" @mouseenter.native="handleHoverEnter(item)">
                <template slot="content">
                  <p>序列号：{{ item.deviceCode }}</p>
                  <p>定位地址：
                    <a @click="openAmapNavigation(item)" v-if="item.formattedAddress" :title="item.formattedAddress">
                      {{ item.formattedAddress || '-' }}
                    </a>
                  </p>
                </template>
                <div class="item_h">
                  <div class="item_h_l">
                    <div class="item_h_u">{{ item.deviceName }}</div>
                    <div class="item_h_t">
                      {{ item.alarmType == 0 ? '电池故障 ' : item.alarmType == 1 ? 'SIM卡故障' : item.alarmType == 2 ?
                        '通讯故障' : item.alarmType == 3 ? '终端故障 ' : item.alarmType == 4 ? '测量故障' : item.alarmType == 5 ?
                          '元件故障' : '阴极保护电位报警' }}
                    </div>
                  </div>
                  <div>时间:{{ item.createTime }}</div>
                </div>
                <div class="item_c">序列号：{{ item.deviceCode }}
                  <div class="item_c_r">
                    <div class="ellipsis">
                      {{ item.formattedAddress }}
                    </div>
                    <img
                      src="~@/assets/images/jian.png"
                      alt=""
                    >
                  </div>
                </div>
              </a-popover>
            </div>
          </div>
        </div>
        <div class="content_l_t">
          <div class="content_l_u">
            <div></div>
            数据统计
          </div>
          <div class="content_l_y">
            <lineCharts :chartData="chartData3"></lineCharts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import GdMap from '@/components/MAP/index.vue'
// import lineChart from './Charts/lineChart.vue'
import bingChart from './Charts/bing.vue'
import bingCharts from './Charts/bings.vue'
import lineCharts from './Charts/lineCharts.vue'
import { getRouters } from '@/api/menu'
import { homeDev, alarmList } from '@/api/home'
import { listPipeline, listDevice } from '@/api/saifuneng/devicedata'

// import { devList, devPx, devNum, devYj, carTj, devJk, sysTree, getDevice } from '@/api/home'
// import { listCompany } from '@/api/project/company'
// import { mapGetters } from 'vuex'
export default {
  components: {
    GdMap,
    lineCharts,
    bingChart,
    bingCharts
  },
  // computed: {
  //   ...mapGetters([getRouters
  //     'roles',
  //     'tenantIds'
  //   ])
  // },
  data () {
    return {
      hovered: false,
      codeUrl: '',
      date: new Date(),
      dates: new Date(),
      pipelineList: [],
      deviceList: [],
      chartData1: {},
      chartData2: {},
      chartData3: {},
      queryParam: {
        typeTime: 0,
        createBeginTime: '',
        createEndTime: '',
        provinceCode: '',
        type: 0,
        devId: ''
      },
      queryParam1: {
        provinceCode: undefined,
        tenantId: undefined,
        devName: '',
        devId: undefined
      },
      queryParam2: {
        type: 0,
        devName: ''
      },
      devNumAll: '',
      timer: '',
      agentList: [],
      treeList: [],
      devList: [],
      chartData: {},
      info: {},
      week: '',
      option: [{ id: 0, name: '预警车辆排序' }, { id: 1, name: '超速车辆排序' }, { id: 2, name: '未超速车辆排序' }, { id: 3, name: '车流量排序' }, { id: 4, name: '设备在线率排序' }, { id: 5, name: '设备故障率排序' }, { id: 6, name: '设备电量率排序' }],
      options: [{ id: 0, name: '预警车辆统计' }, { id: 1, name: '超速车辆查询' }, { id: 2, name: '未超速车辆查询' }, { id: 3, name: '车流量查询功能' }],
      checkedList: [0],
      checked: 0,
      queryParam: {
        pipelineId: undefined,
        deviceCode: undefined
      },
      indeterminate: true,
      checkAll: false,
      devPai: [],
      role: '',
      companyList: [],
      dataList: []
    }
  },
  mounted () {
    const that = this
    this.timer = setInterval(function () {
      that.date = moment().format('YYYY年MM月DD日')
      that.dates = moment().format('HH:mm:ss')
      const week = moment().day()
      let weeks
      if (week === 1) {
        weeks = '周一'
      } else if (week === 2) {
        weeks = '周二'
      } else if (week === 3) {
        weeks = '周三'
      } else if (week === 4) {
        weeks = '周四'
      } else if (week === 5) {
        weeks = '周五'
      } else if (week === 6) {
        weeks = '周六'
      } else if (week === 0) {
        weeks = '周日'
      }
      that.week = weeks
    })

    // this.chartData = {
    // }
  },
  beforeDestroy: function () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    // if (timerNum) {
    // }
    clearInterval(timerNum)
  },
  created () {
    this.getDev()
    // console.log(1111111111111);
    // // 向后端请求路由数据
    // getRouters().then(res => {
    //   console.log(res, '頂頂頂======');
    //   // 路由菜单分离，路由全部为二级，解决多级菜单缓存问题
    //   // this.path = '/' + res.data[0].path
    //   this.$router.push({ path: '/index' }).catch(() => { })
    //   // this.path = '/' + 'deviceList'
    //   console.log(this.path, '测试萨达萨达')
    // })
    this.getPipelineList()
    this.getDeviceList('')
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    getPipelineList () {
      listPipeline().then(response => {
        this.pipelineList = response.data
      })
    },
    getDeviceList (pipelineId) {
      listDevice({ 'pipelineId': pipelineId }).then(response => {
        this.deviceList = response.data
      })
    },
    // 查询数据大屏数据
    getDev () {
      homeDev(this.queryParam).then(res => {
        res = res.data
        this.info = res
        console.log(res, 'ddddd对对对')
        this.chartData1 = {
          underProtection: res.underProtection,
          overProtection: res.overProtection,
          normalProtection: res.normalProtection
        }
        this.chartData2 = {
          offline: res.offline,
          fault: res.fault,
          online: res.online
        }

        this.chartData3 = {
          city: res.cityList.map(v => v.city),
          deviceCount: res.cityList.map(v => v.deviceCount)
        }
        this.$nextTick(() => {
          this.$refs.map.init(res.coordinateList)
        })
        console.log(this.chartData1, 'dddd嘟嘟嘟嘟')
      })
      alarmList().then(res => {
        console.log(res, '大大大大大')
        this.dataList = res.data
      })
    },
    // 选择设备
    handleChangeBu (e) {
      this.queryParam.devId = e
    },
    handleChange (e) {
      this.getDev()
    },
    // 选择部门查询设备列表
    handleChangeDev (e) {
      console.log(e, '滴滴滴滴滴滴')
      this.queryParam.tenantId = e
      this.getDev()
    },
    // 搜索地图
    handleSeach () {
      this.$nextTick(() => {
        this.$refs.map.getMap(this.queryParam1, 1)
      })
      this.getDevNum()
      this.getYj()
      this.GuoTj()
    },
    // 设备排行
    getPh () {
      devPx(this.queryParam2).then(res => {
        this.devPai = res.data
      })
    },
    // 实时预警
    getYj () {
      devYj(this.queryParam1).then(res => {
        this.devList = res.data
      })
    },
    // 查询设备数据
    getDevNum () {
      console.log('测试是否进入设备====')
      const query = {
        arr: []
      }
      devNum(this.queryParam1).then(res => {
        this.devNumAll = res.data.devNumAll
        res = res.data.list
        res.forEach(v => {
          if (v.onLine === 1) {
            query.arr.push({ value: v.devNum, name: '在线', itemStyle: { color: '#489bfb' } })
          } else if (v.onLine === 2) {
            query.arr.push({ value: v.devNum, name: '故障', itemStyle: { color: '#edc910' } })
          } else {
            query.arr.push({ value: v.devNum, name: '离线', itemStyle: { color: '#bbe7f2' } })
          }
        })
        console.log(this.chartData1, 'this.chartData1this.chartData1')
        this.chartData1 = query
      })
    },
    handleTime (e) {
      console.log(e, '滴滴滴滴滴滴')
      this.queryParam.createBeginTime = e[0].format('YYYY-MM-DD')
      this.queryParam.createEndTime = e[1].format('YYYY-MM-DD')
    },
    pipelineIdChange (e) {
      this.queryParam.deviceCode = undefined
      this.getDeviceList(this.queryParam.pipelineId)
      this.getDev()
    },
    onChange (e) {
      console.log(e, '滴滴滴滴滴滴')
      // this.indeterminate = !!checkedList.length && checkedList.length < plainOptions.length
      // this.checkAll = checkedList.length === plainOptions.length
      if (e.length > 1) {
        console.log(this.checked, 'ddddddsss')
        console.log(e, '大大大大大')
        const num = e.filter(v => v !== this.checked)[0]
        console.log(num, '滴滴滴滴滴滴')
        this.checked = num
        this.queryParam.typeTime = num
        this.checkedList = [num]
        this.GuoTj()
        // const num = e[1]
        // if (num === '时') {
        //   this.queryParam.typeTime = 0
        // } else if (num === '日') {
        //   this.queryParam.typeTime = 1
        // } else if (num === '日') {
        //   this.queryParam.typeTime = 2
        // } else if (num === '周') {
        //   this.queryParam.typeTime = 3
        // } else if (num === '月') {
        //   this.queryParam.typeTime = 4
        // } else if (num === '年') {
        //   this.queryParam.typeTime = 5
        // }
        // e.splice(0, 1)
      } else if (e.length === 0) {
        this.checked = [this.queryParam.typeTime]
        this.checkedList = [this.queryParam.typeTime]
      }
    },
    handleHome () {
      console.log(this.path, 'dddd頂頂頂頂')
      // console.log(this.$router, '大大大大大')
      this.$router.push({ path: '/index' })
    },
    /**
     * @desc hover方法触发
     * @param {  }
     * @version: 1.0.0
     */
    handleHoverEnter(item) {
      // console.log('鼠标悬浮了', item)
      // 你要执行的逻辑
      this.$nextTick(() => {
        this.$refs.map.toMapCenter(item)
      })
    },
    handleDev (item) {
      console.log(item, '大大大大大123123')
      console.log(this.$router)
      // deviceCategorizeCode
      if (item.deviceCategorizeCode != null) {
        if (item.deviceCategorizeCode === 'yin_protection_pile') {
          this.$router.push({ name: 'Device', params: { deviceCode: item.deviceCode } })
        } else if (item.deviceCategorizeCode === 'electric_drainage') {
          this.$router.push({ name: 'Electric_drainage', params: { deviceCode: item.deviceCode } })
        } else if (item.deviceCategorizeCode === 'recorder') {
          this.$router.push({ name: 'Recorder', params: { deviceCode: item.deviceCode } })
        }
      }
    },
    /** 打开高德导航 */
    openAmapNavigation(record) {
      var fromLongitude = ''
      var fromLatitude = ''
      var fromPlaceName = ''
      this.getCurrentLocation().then(res => {
        fromLongitude = res.longitude
        fromLatitude = res.latitude
        var toLongitude = record.deviceLongitude
        var toLatitude = record.deviceLatitude
        var toPlaceName = record.formattedAddress
        console.log('起点：' + fromLongitude + ',' + fromLatitude)
        console.log('终点：' + toLongitude + ',' + toLatitude)
        const url = `https://uri.amap.com/navigation?from=${fromLongitude},${fromLatitude},${encodeURIComponent(fromPlaceName)}&to=${toLongitude},${toLatitude},${encodeURIComponent(toPlaceName)}&mode=car&policy=0&callnative=1`
        window.open(url, '_blank')
      }).catch(err => {
        this.$message.warning(err)
      })
    },
    getCurrentLocation() {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('浏览器不支持定位功能'))
          return
        }
        navigator.geolocation.getCurrentPosition(
          // 成功回调
          (position) => {
            const location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              accuracy: position.coords.accuracy,
              altitude: position.coords.altitude,
              altitudeAccuracy: position.coords.altitudeAccuracy,
              heading: position.coords.heading,
              speed: position.coords.speed,
              timestamp: position.timestamp
            }
            resolve(location)
          },
          // 失败回调
          (error) => {
            let errorMessage = ''
            switch (error.code) {
              case error.PERMISSION_DENIED:
                errorMessage = '用户拒绝定位请求'
                break
              case error.POSITION_UNAVAILABLE:
                errorMessage = '位置信息不可用'
                break
              case error.TIMEOUT:
                errorMessage = '定位请求超时'
                break
              case error.UNKNOWN_ERROR:
                errorMessage = '未知错误'
                break
            }
            reject(errorMessage)
          },
          // 可选配置
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
          }
        )
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>

<style lang="less" scoped>
.homePage {
  background: #000000;
  width: 100%;
  height: 100vh;
  color: #fff;
  padding-top: 20px;

  .homePage_top {
    height: 50px;
    background: url(~@/assets/images/home_bei.png) no-repeat;
    background-size: 100% 100%;
    padding-left: 32px;
    padding-right: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 28px;

    .homePage_l {
      font-size: 26px;
      font-weight: bold;
      display: flex;

      align-items: center;

      span {
        padding-bottom: 15px;
      }

      .guanxian {
        display: flex;
        align-items: center;
        margin-left: 20px;
      }

      .gongzuo {
        margin-left: 281px;
        width: 85px;
        height: 40px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #5DD2D7;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        cursor: pointer;

        img {
          width: 16px;
          height: 16px;
          margin-right: 9px;
        }
      }
    }

    .homePage_r {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #DBEDFF;
      font-size: 16px;

      img {
        width: 16px;
        height: 16px;
        margin-right: 14px;
      }

      div {
        margin-left: 10px;
        margin-right: 5px;
      }
    }
  }

  .home_content {
    padding: 0 23px;
    display: flex;

    .content_l_t {
      height: 49%;
      background: url(~@/assets/images/home_bei1.png) no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;

      .content_l_u {
        padding-left: 17px;
        color: #F8F8F9;
        padding-top: 10px;
        font-size: 18px;
        display: flex;
        align-items: center;

        div {
          width: 3px;
          height: 16px;
          background: #FFFFFF;
          margin-right: 7px;
          border-radius: 0px 0px 0px 0px;
        }
      }

      .content_l_y {
        flex: 1;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        padding: 20px;
        position: relative;

        .content_l_p {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          // background: red;
          // width: 25%;
          // height: 25%;
          text-align: center;
          font-size: 30px;
          color: #F8F8F9;

          .content_l_k {
            font-size: 20px;
          }
        }

      }
    }

    .content_l {
      height: calc(100vh - 110px);
      width: 482px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 22px;

      &:last-child {
        margin-left: 22px;
        margin-right: 0;
      }

    }

    .con_map {
      flex: 1;
    }
  }

  .con_y_u {
    overflow-y: auto;

    /* 隐藏滚动条的整个部分 */
    &::-webkit-scrollbar {
      display: none;
    }

    .con_item {
      padding-left: 14px;
      padding-right: 23px;
      padding-bottom: 19px;
      margin-bottom: 19px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.14);

      &:last-child {
        border: none;
        margin-bottom: 0;
      }

      .item_h {
        display: flex;
        align-items: center;
        margin-bottom: 9px;
        justify-content: space-between;

        .item_h_l {
          display: flex;
          align-items: center;

          .item_h_u {
            font-size: 16px;
            font-weight: bold;
          }

          .item_h_t {
            display: flex;
            align-items: center;
            justify-content: center;
            // width: 64px;
            padding: 0 5px;
            height: 20px;
            color: #FF7878;
            margin-left: 13px;
            background: rgba(255, 87, 87, 0.2);
            border-radius: 4px 4px 4px 4px;
          }
        }
      }

      .item_c {
        font-size: 14px;
        display: flex;
        align-items: center;
        cursor: pointer;

        .item_c_r {
          margin-left: 21px;
          display: flex;
          align-items: center;
          flex: 1;
          justify-content: space-between;

          div {
            width: 200px;
          }
        }
      }
    }
  }

}

.ant-page-header-ghost {
  display: none !important;
}

/deep/.ant-select-selection {
  background: transparent !important;
  width: 200px;
  margin-right: 20px;
  color: #fff;
}
</style>
